import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import goodJobSvg from '../images/goodJob.svg';
import TextField from '@material-ui/core/TextField';
import Transition from './Dialogs/Transition';

const styles = {
	goodJobIcon: {
		display: 'inline-block',
		width: 50,
		height: 50,
		backgroundImage: `url('${goodJobSvg}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
	},
	label: {},
	value: {
		fontWeight: 600,
	},
	current: {},
	new: {
		marginTop: 20,
	},
};

export default class DgsDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			newDgsValue: '',
			dgsError: '',
		};

		this.handleRequestClose = this.handleRequestClose.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
	}

	handleRequestClose() {
		this.props.onClose();
	}

	handleUpdate() {
		const params = {};
		params.fieldName = 'dgs.westCoast.e85Rate';
		const newValue = this.state.newDgsValue;

		if (!parseFloat(newValue) || newValue < 1.0 || newValue > 5.0) {
			this.setState({ dgsError: 'Invalid GGS value must be a decimal between 1.0 and 5.0.' });
			return;
		}
		params.fieldValue = parseFloat(newValue);

		this.props.addDataRecord({
			params,
			callback: function (err) {
				if (!err) {
					this.props.onClose();
				}
			}.bind(this),
		});
	}

	onChange(event, fieldName) {
		this.setState({ [fieldName]: event.target.value });
	}

	render() {
		return (
			<Dialog
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleRequestClose}
			>
				<div style={{ padding: '20px 40px' }}>
					<DialogTitle>Update DGS Data</DialogTitle>
					<DialogContent>
						<div style={styles.current}>
							<span style={styles.label}>Current DGS West Coast E85 Rate : </span>
							<span style={styles.value}>{this.props.currentDgsValue}</span>
						</div>

						{this.state.dgsError && (
							<div style={{ padding: 10, color: 'red' }}>{this.state.dgsError}</div>
						)}

						<TextField
							style={styles.new}
							value={this.state.newDgsValue}
							onChange={(event) => this.onChange(event, 'newDgsValue')}
							label="New DGS West Coast E85 Rate"
							fullWidth
						/>

						<DialogContentText></DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleRequestClose}>Cancel</Button>
						<Button variant="contained" onClick={this.handleUpdate} color="primary">
							Update
						</Button>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

DgsDialog.propTypes = {
	open: PropTypes.bool,
	addDataRecord: PropTypes.func.isRequired,
	currentDgsValue: PropTypes.string,
	onClose: PropTypes.func.isRequired,
};
